import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
    companyEmailSelector,
    alternativeEmailSelector,
    isActivatingSelector,
    activatedSelector,
    activationErrorSelector,
    activationCodeSelector
} from '../selectors/wizardSelectors';
import { activateDenwaNanoRequest } from '../actions/wizardActions';
import LicenceActivation from '../components/LicenceActivation/LicenceActivation';

const mapStateToProps = createStructuredSelector({
    companyEmail: companyEmailSelector,
    alternativeEmail: alternativeEmailSelector,
    isActivating: isActivatingSelector,
    activated: activatedSelector,
    activationError: activationErrorSelector,
    activationCode: activationCodeSelector
});

const mapDispatchToProps = { activateDenwaNanoRequest };

export default connect(mapStateToProps, mapDispatchToProps)(LicenceActivation);
